import { DataService } from '../../../shared/services/data.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IncadaTenant } from '../models/incada-tenant';
import { IncadaLocation } from '../models/incada-location';

@Injectable({
  providedIn: 'root',
})
export class IncadaService extends DataService<IncadaTenant> {

  constructor(http: HttpClient) {
    super(`${environment.apiUrl.authorizationService}incada/`, http);
  }

  getActiveTenants(): Observable<IncadaTenant[]> {
    return this.getAll(`${this.url}tenants/active`);
  }

  getLocationSites(tenantSlug: string, regionSlug: string): Observable<IncadaLocation[]> {
    const params = new HttpParams()
      .set('tenantSlug', tenantSlug)
      .set('regionSlug', regionSlug);
    return this.http.get<IncadaLocation[]>(`${this.url}locations/sites`, { params });
  }

  getLocationOrgUnits(tenantSlug: string, regionSlug: string): Observable<IncadaLocation[]> {
    const params = new HttpParams()
      .set('tenantSlug', tenantSlug)
      .set('regionSlug', regionSlug);
    return this.http.get<IncadaLocation[]>(`${this.url}locations/org-units`, { params });
  }
}
